<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="8" md="6">
                <v-text-field v-model="newRole" label="New Role Name" clearable></v-text-field>
            </v-col>
            <v-col cols="2">
                <v-btn :disabled="isSaving || isLoading" :loading="isSaving" @click="createRole" color="secondary" dense
                    >Add Role</v-btn
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :headers="headers"
                    :items="roles"
                    :items-per-page="15"
                    class="elevation-1"
                    single-expand
                    show-expand
                    item-key="name"
                    :expanded.sync="expanded"
                    :footer-props="{
                        showFirstLastPage: true,
                        itemsPerPageOptions: [-1, 10, 15, 20, 25],
                        firstIcon: 'mdi-arrow-collapse-left',
                        lastIcon: 'mdi-arrow-collapse-right',
                        prevIcon: 'mdi-minus',
                        nextIcon: 'mdi-plus',
                    }"
                    @item-expanded="setEditPermissions"
                >
                    <template v-slot:[`expanded-item`]="{ headers, item }">
                        <td :colspan="headers.length" class="pa-1">
                            <v-expansion-panels accordion>
                                <v-expansion-panel v-for="(entity, i) in entities" :key="`e-${i}`">
                                    <v-expansion-panel-header>{{ entity }}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container>
                                            <v-row no-gutters>
                                                <v-col
                                                    v-for="(permission, j) in permissions"
                                                    :key="`p-${j}`"
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <v-checkbox
                                                        dense
                                                        v-model="editPermissions"
                                                        :label="getLabel(permission)"
                                                        :value="`${entity}.${permission}`"
                                                        class="mt-0 text-body-2"
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                            <div class="d-flex justify-center justify-md-end ma-2">
                                <v-btn color="success" @click="updatePermissions(item.name)">Save</v-btn>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import api from '@/api'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
export default {
    name: 'RolesAndPermissionsEditor',
    mixins: [navGuardConfirmMixin],
    data() {
        return {
            isLoading: false,
            isSaving: false,
            expanded: [],
            entities: [],
            permissions: [],
            roles: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
            ],
            editPermissions: [],
            newRole: '',
        }
    },
    mounted() {
        this.getData()
    },
    watch: {
        editPermissions: {
            deep: true,
            handler() {
                this.isDirty = true
            },
        },
    },
    methods: {
        getData() {
            this.isLoading = true
            api.get('role/getAllRolesAndPermissionsData')
                .then(res => {
                    this.entities = res.entities
                    this.permissions = res.permissions
                    this.roles = res.roles
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        setEditPermissions(e) {
            if (!e.value) {
                this.editPermissions = []
                return
            }
            this.editPermissions = e.item.permissions || []
            this.$nextTick(() => {
                this.isDirty = false
            })
        },
        getLabel(string) {
            return this.$options.filters.spacesBeforeCaps(string)
        },
        createRole() {
            this.isSaving = true
            api.post(`role/createRole/${this.newRole}`)
                .then(() => {
                    this.roles.push({ name: this.newRole })
                    this.newRole = ''
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        updatePermissions(roleName) {
            this.isSaving = true
            api.post(`role/updateRolePermissions/${roleName}`, this.editPermissions)
                .then(() => {
                    this.showSnackbar('success', 'Permissions Updated')
                    this.isDirty = false
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
    },
}
</script>
